"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Input = require("../Input");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var Autocomplete = function Autocomplete(_ref) {
  var autocompleteProps = _ref.autocompleteProps,
    inputProps = _ref.inputProps,
    restProps = _objectWithoutProperties(_ref, ["autocompleteProps", "inputProps"]);
  var caseSensetive = autocompleteProps === null || autocompleteProps === void 0 ? void 0 : autocompleteProps.caseSensetive;
  var nonCaseSensetiveFilter = function nonCaseSensetiveFilter(inputValue, option) {
    return option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1 && inputValue !== option.value;
  };
  return /*#__PURE__*/_react.default.createElement(_antd.AutoComplete, _extends({}, caseSensetive && {
    filterOption: nonCaseSensetiveFilter
  }, restProps, autocompleteProps, {
    className: (0, _classnames.default)('sber-select', autocompleteProps === null || autocompleteProps === void 0 ? void 0 : autocompleteProps.className, 'sber-autocomplete'),
    dropdownClassName: (0, _classnames.default)('sber-select-dropdown', autocompleteProps === null || autocompleteProps === void 0 ? void 0 : autocompleteProps.dropdownClassName, 'sber-select-dropdown-auto', {
      'sber-select-dropdown-lg': (autocompleteProps === null || autocompleteProps === void 0 ? void 0 : autocompleteProps.size) === 'large'
    })
  }), /*#__PURE__*/_react.default.createElement(_Input.Input, _extends({}, inputProps, {
    className: (0, _classnames.default)('sber-input', inputProps === null || inputProps === void 0 ? void 0 : inputProps.className)
  })));
};
var _default = Autocomplete;
exports.default = _default;